import type { CategoryPageQuery, CategoryPageQueryVariables } from 'src/types';

import query from '../query.graphql';
import { usePageQuery } from 'src/hooks/use-page-query';

export function useCategoryPageQuery(variables: CategoryPageQueryVariables) {
  return usePageQuery<CategoryPageQuery>({
    query,
    routeName: 'category',
    variables,
  });
}
